import { createApiConstants } from '@saucelabs/sl-util-redux';

import constants from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, constants.NAMESPACE);

const UPDATE_STARRED_REAL_DEVICES = createApiNamespacedConstants('UPDATE_STARRED_REAL_DEVICES');

const SET_MOBILE_SELECTION_CURRENT_VIEW = `${constants.NAMESPACE}/SET_MOBILE_SELECTION_CURRENT_VIEW`;

const UPDATE_MOBILE_SELECTION_FILTER = `${constants.NAMESPACE}/UPDATE_MOBILE_SELECTION_FILTER`;
const SET_MOBILE_SELECTION_FILTERS = `${constants.NAMESPACE}/SET_MOBILE_SELECTION_FILTERS`;
const CLEAR_MOBILE_SELECTION_FILTER = `${constants.NAMESPACE}/CLEAR_MOBILE_SELECTION_FILTER`;
const UPDATE_MOBILE_SELECTION_SEARCH_TERM = `${constants.NAMESPACE}/UPDATE_MOBILE_SELECTION_SEARCH_TERM`;

const SORT_DEVICES = `${constants.NAMESPACE}/SORT_DEVICES`;

const MOBILE_DEVICES_FETCH = createApiNamespacedConstants('MOBILE_DEVICES_FETCH');
const MOBILE_AVAILABLE_DEVICE_IDS_FETCH = createApiNamespacedConstants('MOBILE_AVAILABLE_DEVICE_IDS_FETCH');
const MOBILE_SESSION_AVAILABLE_FETCH = createApiNamespacedConstants('MOBILE_SESSION_AVAILABLE_FETCH');

export default {
  CLEAR_MOBILE_SELECTION_FILTER,
  MOBILE_AVAILABLE_DEVICE_IDS_FETCH,
  MOBILE_DEVICES_FETCH,
  MOBILE_SESSION_AVAILABLE_FETCH,
  SET_MOBILE_SELECTION_CURRENT_VIEW,
  SET_MOBILE_SELECTION_FILTERS,
  SORT_DEVICES,
  UPDATE_MOBILE_SELECTION_FILTER,
  UPDATE_MOBILE_SELECTION_SEARCH_TERM,
  UPDATE_STARRED_REAL_DEVICES,
};
